var _defs, _path, _rect, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.28003 72.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "38- \u06A9\u0627\u0645\u062A \u0647\u0627") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.17569,261.2328h-56.1a15.30205,15.30205,0,0,0-15.29,15.29v3.89h-16.07a10.518,10.518,0,0,0-10.53,10.53v24.54a10.5137,10.5137,0,0,0,10.53,10.51h1.54v8.05l15.08-8.05h29.36a10.49229,10.49229,0,0,0,8.47-4.25h12.12l21.45,11.44v-11.46a15.318,15.318,0,0,0,14.73-15.29v-29.91A15.30205,15.30205,0,0,0,319.17569,261.2328Zm10.39,45.2a10.40051,10.40051,0,0,1-10.39,10.38995h-4.34v8.18l-15.33-8.18h-36.43a10.392,10.392,0,0,1-10.38-10.38995v-29.91a10.3985,10.3985,0,0,1,10.38-10.39h56.1a10.407,10.407,0,0,1,10.39,10.39Z",
    transform: "translate(-221.18564 -261.2328)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.16003,
    y: 14.38995,
    width: 52.76001,
    height: 3.59003,
    rx: 1.77002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.10569,286.9828v.05a1.76906,1.76906,0,0,1-1.77,1.78h-49.22a1.769,1.769,0,0,1-1.77-1.78v-.05a1.76684,1.76684,0,0,1,1.77-1.77h49.22A1.76688,1.76688,0,0,1,318.10569,286.9828Z",
    transform: "translate(-221.18564 -261.2328)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.10569,295.38276v.05a1.76687,1.76687,0,0,1-1.77,1.77h-49.22a1.76683,1.76683,0,0,1-1.77-1.77v-.05a1.769,1.769,0,0,1,1.77-1.78h49.22A1.76906,1.76906,0,0,1,318.10569,295.38276Z",
    transform: "translate(-221.18564 -261.2328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.10569,303.77277v.05a1.77544,1.77544,0,0,1-1.77,1.78h-49.22a1.77539,1.77539,0,0,1-1.77-1.78v-.05a1.76688,1.76688,0,0,1,1.77-1.77h49.22A1.76692,1.76692,0,0,1,318.10569,303.77277Z",
    transform: "translate(-221.18564 -261.2328)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/Comments.15544ff0982437fac9eeedbdf0cdfef0.svg";
export { ForwardRef as ReactComponent };